import React from 'react';
import './ServicePage.css';

import { Heading, Service, PageTitle } from '../../../components';
import { services, titles } from '../../../constants';

import { useTranslation } from 'react-i18next';

const ServicePage = () => {

    const { t } = useTranslation();
    return (
        <>
            {/* Page Title */}
            <PageTitle title={t('titles.services')} page={'Services'} subTitle={t('titles.subTitleServices')} />

            <section className='services'>

                {/* Section heading */}
                <Heading title={t('services.title')} subTitle={t('services.subTitle')} />

                <div className='box-container'>

                    {/* Map over the services array to render each service */}
                    {services.map((service) => {
                        return (
                            <Service
                                id={service.id}
                                key={service.id}
                                image={service.image}
                                title={service.titleKey}
                                content={service.contentKey} 
                                service={service} 
                                icon={service.icon}
                            />
                        );
                    })}
                </div>

            </section>
        </>
    )
}

export default ServicePage;